// extracted by mini-css-extract-plugin
module.exports = {"container":"container___O9Aiu","list":"list___1pUjT"};